package com.neurobs.ccabserver.subjectsessionview.components.sessionrunview.components

import com.neurobs.react.{Link, ReactElementFactory}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react

@react
object LogfileLink {
  case class Props(testRunId: Long)
  val component = FunctionalComponent[Props] { props =>

     Link(
       caption = "View logfile",
       url = Some(s"/api/v1/test_runs/${props.testRunId}/logfile"),
       newTab = true
     )
  }
}
